var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "uiw:facebook"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_562_1730)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6752 0H1.3248C0.5928 0 0 0.5928 0 1.3248V22.6752C0 23.4072 0.5928 24 1.3248 24H12.8184V14.706H9.6912V11.0844H12.8184V8.412C12.8184 5.3112 14.712 3.624 17.478 3.624C18.8028 3.624 19.9404 3.7224 20.2728 3.7668V7.0068H18.3552C16.8504 7.0068 16.56 7.722 16.56 8.7708V11.0832H20.1468L19.6788 14.7048H16.5588V24H22.6752C23.4072 24 24 23.4072 24 22.6752V1.3248C24 0.5928 23.4072 0 22.6752 0Z",
    fill: "#3B5998"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_562_1730"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.c2beeaee4458a04d8d7e8832295ef00a.svg";
export { ForwardRef as ReactComponent };